import React from "react";
import { useSelector } from "react-redux";
import { setAdditionalClasses } from "../assets/js/utils";

function ResponsiveImage({ images, applyOverlay }) {
  const sections = useSelector((state) => state.ui.sections);
  return (
    <picture>
      <source media="(max-width: 500px)" srcSet={`${images[0]}`} />
      <source
        media="(min-width: 501px) and (max-width: 1024px)"
        srcSet={`${images[1]}`}
      />
      <source media="(min-width: 1025px)" srcSet={`${images[2]}`} />
      <img
        src={`${images[2]}`}
        alt=""
        className={`main-section-image${setAdditionalClasses(
          ["overlay", "border-radius-0"],
          [applyOverlay, sections.displayContent]
        )}`}
      />
    </picture>
  );
}

export default ResponsiveImage;
